import ChangeAccountPassword from "./AccountPassword";
import ChangeMasterPassword from "./MasterPassword";
import EncryptionKeySettings from "./EncryptionKeySettings";
import TwoFA from "./TwoFA";

const securityComponents = {
  ChangeAccountPassword,
  ChangeMasterPassword,
  EncryptionKeySettings,
  TwoFA
}

export default securityComponents